import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import Notifications from "vue-notification";
import QModal from "@/common/plugins/modal";
import messages from "@/i18n";
import VueI18n from "vue-i18n";
import Loading from "vue-loading-overlay";

Vue.use(VueI18n);
Vue.use(Notifications);
Vue.use(QModal);
Vue.use(Loading);

Vue.config.productionTip = false;
const numberFormats = {
  'ja-JP': {
    currency: {
      style: 'currency', currency: 'JPY', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumSignificantDigits: 3, maximumSignificantDigits: 7
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
};
const trans18next = new VueI18n({
  locale: "ja",
  messages,
  numberFormats,
});

const vueApp = new Vue({
  router,
  i18n: trans18next,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vueApp;
